import React, {} from "react";
import { } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  List,
  Progress
} from '@lockerpm/design';

import {
  ProjectOutlined
} from "@ant-design/icons";

import itemsComponents from "../items";

const ImportExportProgressForm = (props) => {
  const { TextCopy } = itemsComponents;
  const { t } = useTranslation()
  const {
    selectedProjects = [],
  } = props;

  return (
    <List
      itemLayout="horizontal"
      dataSource={selectedProjects}
      renderItem={(p) => (
        <List.Item>
          <div
            className="flex items-center justify-between w-full"
            key={`${p.id}_${p.pSecrets.length}_${p.pEnvironments.length}`}
          >
            <div className="w-2/3 flex items-center">
              <ProjectOutlined
                className={`mr-2 ${p.percent == 100 ? 'text-primary' : ''}`}
                style={{ fontSize: 24 }}
              />
              <div className="flex-1">
                <TextCopy className={`font-semibold`} value={p.name}/>
                <div className="flex items-center w-full text-xs text-black-400">
                  <p className="w-1/3">
                    {t('secrets.title')}: <span className="font-semibold">
                      <span>{p.pSecrets.length}</span>
                      <span className="mx-1">/</span>
                      <span>{p.total_secret}</span>
                    </span>
                  </p>
                  <p className="font-bold mx-4">|</p>
                  <p className="flex-1">
                    {t('environments.title')}: <span className="font-semibold">
                      <span>{p.pEnvironments.length}</span>
                      <span className="mx-1">/</span>
                      {p.total_environment}
                    </span>
                  </p>
                </div>
              </div>
            </div>
            <div className="flex-1">
              <Progress
                percent={p.percent}
                size="small"
                style={{ marginInlineEnd: 0 }}
              />
            </div>
          </div>
        </List.Item>
      )}
    />
  );
}

export default ImportExportProgressForm;